import { render } from "./About.vue?vue&type=template&id=d7377bd8"
const script = {}
script.render = render

export default script